/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Mentions_Link_Choice_FileInputs */



/**
* | output |
* | --- |
* | "Link this file" |
*
* @param {Chat_Mentions_Link_Choice_FileInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_mentions_link_choice_file = /** @type {((inputs?: Chat_Mentions_Link_Choice_FileInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Mentions_Link_Choice_FileInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur diese Datei verknüpfen")
	return /** @type {LocalizedString} */ ("Link this file")
});